import Vue from 'vue'
import Vuex from 'vuex'
import user from './user'
import application from './application'
import admin from './admin'
import jury from './jury'
import schedule from './schedule'
import moment from 'moment'

Vue.use(Vuex)

const store = new Vuex.Store({
  modules: {
    user,
    application,
    admin,
    jury,
    schedule
  },
  state: {
    error: '',
    message: '',
    applicationLaunchDate: '2023-12-08T08:00Z',
    applicationTlEndDate: '2024-02-05T22:00Z',
    applicationEndDate: '2024-03-04T22:00Z',
    juryDeadline: '2024-04-26T22:00Z',
    acceptanceDate: '2024-05-20T22:00Z',
    confirmationDeadline: '2024-06-29T22:00Z',
    schedulesOutDate: '2024-08-04T22:00Z'
  },
  getters: {
    isError: (state) => {
      return state.error.length > 0
    },
    isMessage: (state) => {
      return state.message.length > 0
    },
    isAfterLaunchDate: (state) => {
      return moment().tz('UTC').isAfter(state.applicationLaunchDate)
    },
    isAfterDeadline: (state) => {
      return true // moment().tz('UTC').isAfter(state.applicationEndDate)
    },
    isBeforeDeadline: (state) => {
      return false // moment().tz('UTC').isBefore(state.applicationEndDate)
    },
    pastTLAppDeadline: (state) => {
      return moment().tz('UTC').isAfter(state.applicationTlEndDate)
    },
    isAfterSchedulesOut: (state) => {
      return moment().tz('UTC').isAfter(state.schedulesOutDate)
    },
    isAfterConfirmationDeadline: (state) => {
      return moment().tz('UTC').isAfter(state.confirmationDeadline)
    }
  },
  mutations: {
    error (state, { message }) {
      if (message === 'Failed to fetch') {
        state.error = 'Unable to complete request. If this continues to persist, email sv-s2024@siggraph.org'
      } else {
        state.error = message
      }
    },
    clearError (state) {
      state.error = ''
    },
    message (state, { message }) {
      state.message = message
    },
    clearMessage (state) {
      state.message = ''
    }
  }
})

export default store



// WEBPACK FOOTER //
// ./src/store/index.js